/**
 * 查看工单
 *
 */
import { Form, Input, Tabs } from 'antd'

const { TabPane } = Tabs
import { useEffect, useRef, useState } from 'react'
import { get } from 'lodash-es'
import { CheckThePhoneInp } from '@/pages/homePage/components/addClue'
import {
  checkVipPicturePre,
} from '@/pages/homePage/components/taskList/components/workDetail.tsx'
import { getUser } from 'shj-utils'
import { getIssueDetail, getWorkerOrderDetail } from '@/services/homeService.ts'
import { getFileUrlPrefix } from '@/services'
import { SBack, SGeneralForms } from 'shj-components'
import { keysToList } from '@/utils/common.ts'
import { WorkDetail, CallBackLog, DisposeLog, OperateLog, BackLog } from '@/pages/vip/components'
import { ticketsDetail, ticketsGetLoginUserAttr } from '@/services/customerServices.ts'
import { useParams } from 'react-router-dom'

export const WorkDetailTab = (props: any) => <ModalWorkDetailDom {...props} />
export default (props: any) => {
  const { issueId, id, companyCode } = useParams() || {}
  console.log(useParams())
  return <ModalWorkDetailDom issueId={issueId} id={id} companyCode={companyCode} />
}

function ModalWorkDetailDom(props: any) {
  const { fn, companyCode, formOnly } = props
  const formRef = useRef<any>()
  const { id, issueId } = useParams()
  const [detailsInfo, setDetailsInfo] = useState<any>({})
  const [orderList, setOrderList] = useState<any>({})
  const [customerInfo, setCustomerInfo] = useState<any>({})
  const [disposeLog, setDisposeLog] = useState<any>({})
  const [baseUrl, setBaseUrl] = useState<any>('')

  const [workerOrderDetail, setWorkerOrderDetail] = useState<any>()

  const [isCreatePerson, setIsCreatePerson] = useState<any>()
  const [isDisposePerson, setIsDisposePerson] = useState<any>()
  const [isChargePerson, setIsChargePerson] = useState<any>()
  const [isCopyPerson, setIsCopyPerson] = useState<any>()
  const [currentStatus, setCurrentStatus] = useState<any>()
  const [dataLevel, setDataLevel] = useState<any>()

  const baseInfoConfig = [
    {
      isShowBottomBorder: false,
      formItem: [
        {
          name: 'statusDisplay',
          label: '问题状态',
          spanCol: 6,
        },
        {
          name: 'channelDisplay',
          label: '来源',
          spanCol: 6,
        },
        {
          name: 'classifyDisplay',
          label: '分类',
          spanCol: 6,
        },
        {
          name: 'typeDisplay',
          label: '类型',
          spanCol: 6,
        },
        {
          name: 'customerName',
          label: '客户名称',
          spanCol: 6,
        },
        {
          label: '所属门店',
          name: 'companyName',
          spanCol: 6,
        },
        {
          label: '联系电话',
          name: 'feedbackPhone',
          spanCol: 6,
          customRender: () => {
            return feedbackPhoneRender()
          },
        },
        {
          label: '签约电话',
          name: 'phone',
          spanCol: 6,
          customRender: () => {
            return signPhoneRender()
          },
        },
        {
          name: 'stateDisplay',
          label: '客户状态',
          spanCol: 6,
        },
        {
          name: 'buildingName',
          label: '楼盘名称',
          spanCol: 6,
        },
        {
          name: 'houseNumber',
          label: '房号',
          spanCol: 12,
        },
        {
          name: 'projectCode',
          label: '项目编号',
          spanCol: 6,
        },
        {
          name: 'typeDisplay',
          label: '需求类型',
          spanCol: 6,
        },
        {
          name: 'designDeptDisplay',
          label: '设计部门',
          spanCol: 6,
        },
        {
          name: 'designerDisplay',
          label: '设计师',
          spanCol: 6,
        },
        {
          name: 'designerManager',
          label: '设计部经理',
          spanCol: 6,
        },
        {
          name: 'deliveryDept',
          label: '交付部门',
          spanCol: 6,
        },
        {
          name: 'projectManager',
          label: '项目经理',
          spanCol: 6,
        },
        {
          name: 'engineeringSupervision',
          label: '质检员',
          spanCol: 6,
        },
        {
          name: 'softSteward',
          label: '软装管家',
          spanCol: 6,
        },
        {
          name: 'deliveryManager',
          label: '交付经理',
          spanCol: 6,
        },
        {
          name: 'handoverDate',
          label: '交付日期',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'planStartDate',
          label: '计划开工日期',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'planEndDate',
          label: '计划完工日期',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'actualStartDate',
          label: '实际开工日期',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'actualEndDate',
          label: '实际竣工日期',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'disclosureDate',
          label: '交底日期',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'remoteSite',
          label: '是否远程工地',
          spanCol: 6,
        },
        {
          name: 'visual',
          label: '是否可视化工地',
          spanCol: 6,
        },
        {
          name: 'levelDisplay',
          label: '工单级别',
          spanCol: 6,
        },
        {
          name: 'createdTime',
          label: '创建时间',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'description',
          label: '问题描述',
          spanCol: 24,
        },
        {
          name: 'file',
          label: '问题附件',
          spanCol: 24,
          customRender: () => {
            return filesRender()
          },
        },
      ],
    },
  ]
  const feedbackPhoneRender = () => {
    return (
      <div style={{ display: 'flex' }}>
        联系电话：
        <div style={{ display: 'flex' }}>
          {detailsInfo.feedbackPhone_}
          <CheckThePhoneInp
            defaultValue
            id={id}
            sysItem={'WORKER_ORDER'}
            param1={'联系电话'}
            fn={(val: any) => {
              setDetailsInfo({
                ...detailsInfo,
                feedbackPhone_: val ? val : detailsInfo?.feedbackPhone,
              })
            }}
            encodeValue={encodeURIComponent(detailsInfo?.feedbackPhoneEncode)}
          />
        </div>
      </div>
    )
  }
  const signPhoneRender = () => {
    return (
      <div style={{ display: 'flex' }}>
        签约电话：
        <div style={{ display: 'flex' }}>
          {customerInfo.phone_}
          <CheckThePhoneInp
            defaultValue
            id={id}
            sysItem={'WORKER_ORDER'}
            param1={'签约电话'}
            fn={(val: any) => {
              setCustomerInfo({ ...customerInfo, phone_: val ? val : customerInfo?.phone })
            }}
            encodeValue={encodeURIComponent(customerInfo?.phoneEncode)}
          />
        </div>
      </div>
    )
  }

  const filesRender = () => {
    return (
      <Form.Item label="问题附件" name="drawDesc">
        {detailsInfo?.files &&
          JSON.parse(detailsInfo.files).map((v: any) => {
            return (
              <a href={checkVipPicturePre(baseUrl, v.path)} target="_blank" title={v.name}>
                <img
                  style={{ height: '60px', width: '60px', margin: '5px' }}
                  src={checkVipPicturePre(baseUrl, v.path)}
                  alt={v.name}
                />
              </a>
            )
          })}
      </Form.Item>
    )
  }

  useEffect(() => {
    const user = getUser()
    const group = get(user, 'currentRoles[0].dataLevel')
    setDataLevel(group)
    initFn()
  }, [])

  const initFn = async () => {
    const data = await Promise.all([
      ticketsDetail(id),
      ticketsGetLoginUserAttr(id),
      getFileUrlPrefix(),
    ]) // getLoginUserAttr(id)
    // setBaseUrl(data[2]);
    setCustomerInfo({ ...data[0]?.customerInfo, phone_: data[0]?.customerInfo?.phone })
    setOrderList(data[0]?.orderList)
    setDisposeLog(data[0]?.disposeLog)
    setDetailsInfo({
      ...data[0]?.issueList,
      feedbackPhone_: data[0]?.issueList?.feedbackPhone,
      isRepeatCn: data[0]?.isRepeat ? '是' : '否',
    })
    setWorkerOrderDetail({ ...data[0] })

    setIsCreatePerson(data[1]?.isCreatePerson)
    setIsDisposePerson(data[1]?.isDisposePerson)
    setIsChargePerson(data[1]?.isChargePerson)
    setIsCopyPerson(data[1]?.isCopyPerson)
    setCurrentStatus(data[1]?.status)
  }

  return (
    <SBack level={2} title={'工单详情'}>
      <div style={{ padding:' 0 20px 20px', backgroundColor: '#fff', borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px' }}>
        <SGeneralForms
          ref={formRef}
          isHideResetBtn={true}
          isDetail={true}
          configs={baseInfoConfig}
          initialValues={{ feedbackPhone: detailsInfo?.feedbackPhone, phone: customerInfo?.phone }}
          detailsData={{
            ...{ custStateDisplay: customerInfo?.stateDisplay },
            ...{ custTypeDisplay: customerInfo?.typeDisplay },
            ...orderList,
            ...customerInfo,
            ...detailsInfo,
            ...{
              remoteSite:
                customerInfo?.remoteSite == 1 ? '是' : customerInfo?.remoteSite == 0 ? '否' : '',
            },
            ...{ visual: customerInfo?.visual == 1 ? '是' : customerInfo?.visual == 0 ? '否' : '' },
            ...{ customerName: customerInfo?.name },
          }}
        />
        <div>
          <Tabs defaultActiveKey="1" onChange={() => {}}>
            <TabPane tab="工单详情" key="1">
              <WorkDetail
                details={workerOrderDetail}
                issueId={issueId}
                id={id}
                companyCode={companyCode}
                orderList={orderList}
                formOnly={
                  (currentStatus == 1 || currentStatus == 2) && (isDisposePerson || isCopyPerson)
                }
                fn={() => {
                  initFn()
                }}
              ></WorkDetail>
            </TabPane>
            <TabPane tab="处理记录" key="2">
              <DisposeLog
                woId={id}
                issueId={issueId}
                formOnly={
                  !(
                    (currentStatus == 2 || currentStatus == 6 || currentStatus == 4 || currentStatus == 5) &&
                    (isDisposePerson || isChargePerson || isCopyPerson)
                  ) || formOnly
                }
                dataDetail={workerOrderDetail}
                fn={() => {
                  initFn()
                }}
              ></DisposeLog>
            </TabPane>
            <TabPane tab="回访记录" key="3">
              <CallBackLog
                formOnly={!(currentStatus == 3 || currentStatus == 5) || formOnly} // && dataLevel == 'dataLevelGroup'
                woId={id}
                issueId={issueId}
                fn={() => {
                  initFn()
                }}
              ></CallBackLog>
            </TabPane>
            <TabPane tab="退回记录" key="4">
              <BackLog detailsInfo={orderList}></BackLog>
            </TabPane>
            <TabPane tab="操作记录" key="5">
              <OperateLog id={id} issueId={issueId} sysItem="WORKER_ORDER"></OperateLog>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </SBack>
  )
}
